document.addEventListener("DOMContentLoaded", () => {
  const roots = document.querySelectorAll(".myapp-collection-carousel-unique");
  if (!roots.length) return;

  roots.forEach((root) => {
    const tabs = root.querySelectorAll(".myapp-tab-button");
    const containers = root.querySelectorAll(".myapp-carousel-container");

    function initCarousel(container) {
      if (!container || container.dataset.carouselInit === "1") return;
      container.dataset.carouselInit = "1";

      const carouselList = container.querySelector(".myapp-carousel-list");
      const prevButton = container.querySelector(".myapp-nav-prev");
      const nextButton = container.querySelector(".myapp-nav-next");
      const scrollbar = container.querySelector(".myapp-custom-scrollbar");
      const scrollbarDrag = container.querySelector(".myapp-custom-scrollbar-drag");

      if (!carouselList || !prevButton || !nextButton || !scrollbar || !scrollbarDrag) return;

      function updateNavButtonsVisibility() {
        if (window.innerWidth <= 600) {
          prevButton.style.display = "none";
          nextButton.style.display = "none";
        } else {
          prevButton.style.display = "none";
          nextButton.style.display = "flex";
        }
      }

      function showPrevButton() {
        if (window.innerWidth > 600) prevButton.style.display = "flex";
      }

      function updateScrollbar() {
        const scrollWidth = carouselList.scrollWidth;
        const clientWidth = carouselList.clientWidth;
        const scrollLeft = carouselList.scrollLeft;
        const scrollbarWidth = scrollbar.clientWidth;

        if (scrollWidth <= clientWidth) {
          scrollbarDrag.style.width = "100%";
          scrollbarDrag.style.transform = "translateX(0px)";
          return;
        }

        const dragWidth = Math.max((clientWidth / scrollWidth) * scrollbarWidth, 30);
        const dragLeft = (scrollLeft / (scrollWidth - clientWidth)) * (scrollbarWidth - dragWidth);

        scrollbarDrag.style.width = dragWidth + "px";
        scrollbarDrag.style.transform = "translateX(" + dragLeft + "px)";
      }

      prevButton.addEventListener("click", () => {
        carouselList.scrollBy({ left: 300, behavior: "smooth" });
        showPrevButton();
        updateScrollbar();
      });

      nextButton.addEventListener("click", () => {
        carouselList.scrollBy({ left: -300, behavior: "smooth" });
        showPrevButton();
        updateScrollbar();
      });

      carouselList.addEventListener("scroll", () => {
        showPrevButton();
        updateScrollbar();
      });

      let isDragging = false;
      let dragStartX = 0;
      let scrollStartX = 0;
      let moved = false;

      carouselList.addEventListener("mousedown", (e) => {
        isDragging = true;
        moved = false;
        dragStartX = e.pageX;
        scrollStartX = carouselList.scrollLeft;
        carouselList.style.cursor = "grabbing";
        e.preventDefault();
      });

      document.addEventListener("mouseup", () => {
        isDragging = false;
        carouselList.style.cursor = "grab";
      });

      document.addEventListener("mousemove", (e) => {
        if (!isDragging) return;
        const dx = e.pageX - dragStartX;
        if (Math.abs(dx) > 5) moved = true;
        carouselList.scrollLeft = scrollStartX - dx;
        showPrevButton();
        updateScrollbar();
      });

      carouselList.querySelectorAll("a").forEach((link) => {
        link.addEventListener("click", (e) => {
          if (moved) e.preventDefault();
        });
      });

      let isScrollbarDragging = false;
      let startX = 0;
      let startScrollLeft = 0;

      scrollbarDrag.addEventListener("mousedown", (e) => {
        isScrollbarDragging = true;
        startX = e.pageX;
        startScrollLeft = carouselList.scrollLeft;
        document.body.style.userSelect = "none";
      });

      document.addEventListener("mouseup", () => {
        isScrollbarDragging = false;
        document.body.style.userSelect = "auto";
      });

      document.addEventListener("mousemove", (e) => {
        if (!isScrollbarDragging) return;

        const dx = e.pageX - startX;
        const scrollWidth = carouselList.scrollWidth - carouselList.clientWidth;
        const scrollbarWidth = scrollbar.clientWidth - scrollbarDrag.clientWidth;

        const scrollDelta = (dx / scrollbarWidth) * scrollWidth;
        carouselList.scrollLeft = startScrollLeft + scrollDelta;

        showPrevButton();
        updateScrollbar();
      });

      scrollbar.addEventListener("mousedown", (e) => {
        if (e.target === scrollbarDrag) return;

        const rect = scrollbar.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const dragCenter = scrollbarDrag.offsetLeft + scrollbarDrag.offsetWidth / 2;

        const scrollWidth = carouselList.scrollWidth - carouselList.clientWidth;
        const scrollbarWidth = scrollbar.clientWidth - scrollbarDrag.offsetWidth;

        const delta = ((clickX - dragCenter) / scrollbarWidth) * scrollWidth;

        carouselList.scrollBy({ left: delta, behavior: "smooth" });
        showPrevButton();
        updateScrollbar();
      });

      updateScrollbar();
      updateNavButtonsVisibility();

      window.addEventListener("resize", () => {
        updateNavButtonsVisibility();
        updateScrollbar();
      });
    }

    containers.forEach((container) => initCarousel(container));

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const tabId = tab.dataset.tab;

        tabs.forEach((t) => {
          t.classList.remove("active");
          t.setAttribute("aria-selected", "false");
        });

        tab.classList.add("active");
        tab.setAttribute("aria-selected", "true");

        containers.forEach((c) => {
          if (c.dataset.tab === tabId) {
            c.classList.remove("hidden");
            initCarousel(c);
          } else {
            c.classList.add("hidden");
          }
        });

        const activeContainer = root.querySelector(".myapp-carousel-container:not(.hidden)");
        if (activeContainer) {
          const list = activeContainer.querySelector(".myapp-carousel-list");
          if (list) list.dispatchEvent(new Event("scroll"));
        }
      });
    });
  });
});
